<template>
    <div class="brand-item aspect-square block" :class="sizeClass" :id="brand.name">
        <router-link :to="brand.to"
            class="flex justify-center items-center w-full h-full aspect-square bg-white">
            <img :src="brand.img" :alt="brand.name" class="bg-image" />
            <img :src="brand.logo" :alt="brand.name + ' logo'" class="brand-logo" />
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'BrandTile',
    props: {
        brand: {
            type: Object,
            required: true
        },
        sizeClass: {
            type: String,
            default: 'w-1/2 md:w-1/5'
        }
    }
}
</script>

<style scoped lang="scss">
.brand-item {
    transition: transform 0.3s ease;
    position: relative;
    overflow: hidden;

    .bg-image {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;
        object-fit: cover;
        width: 102%;
        height: 102%;
        filter: grayscale(100%);
        transition: all 0.45s ease;
    }

    .brand-logo {
        position: relative;
        z-index: 1;
        width: 100%;
        height: 100%;
    }

    &:hover {
        .bg-image {
            filter: grayscale(0%);
            width: 120%;
            height: 120%;
        }
    }
}
</style>
